<template>
    <div class="complaints">
        <h2>Постановка окончательного диагноза</h2>
        <h4>Заболевание</h4>
        <div v-for="(item, key) in getDiagnostic.finaly" :key="key" class="item-combo">
            <v-autocomplete
                readonly
                label=""
                outlined
                height="46"
                :items="getDiagnostic.mkbList"
                @change="save({
                    obj: item,
                    url: 'DiaTest/AddOrUpdateDiagnose',
                    index: key,
                    nameGroup: 'diagnostic',
                    nameProperty: 'finaly'
                })"
                item-text="nameCode"
                item-value="id"
                class="item-combo__select"
                v-model="item.diagnoseId"
            />
        </div>

        <TimeoutSnackbar :options="snackbar" />
    </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import TimeoutSnackbar from '@/components/TimeoutSnackbar.vue';

export default {
    name: 'Syndromic',
    components: { TimeoutSnackbar },
    props: {
        name: String
    },
    computed: {
        ...mapGetters({
            getDiagnostic: 'createDiagnosticTest/getDiagnostic',
            getFlagReadonly: 'createDiagnosticTest/getFlagReadonly'
        })
    },
    data() {
        return {
            snackbar: {
                show: false,
                text: null,
                color: null,
                timeout: -1
            },
            itemsMkb: []
        }
    },
    methods: {
        ...mapActions({
            getMkb: 'createDiagnosticTest/getMkb',
            getDataDiagnoses: 'createDiagnosticTest/getDataDiagnoses',
            saveInline: 'createDiagnosticTest/saveInline'
        }),
        ...mapMutations({
            changeFlagMissingStep: 'createDiagnosticTest/changeFlagMissingStep',
            addDiagnose: 'createDiagnosticTest/addDiagnose'
        }),
        save(obj) {
            if(obj.obj.diagnoseId) {
                obj.obj.diagnoseName = this.getDiagnostic.mkbList.find((f) => f.id === obj.obj.diagnoseId).name
            }

            this.saveInline(obj)
            .then(() => {
                this.snackbar = { text: 'Изменения сохранены успешно!', color: 'success', timeout: 3000, show: true };
            })
            .catch((error) => {
                if(error) {
                    this.snackbar = { text: 'Ошибка сохранения данных, обратитесь к Администратору!', color: 'error', timeout: 3000, show: true };
                }
            })
        }
    },
    created() {
        // Если предыдущая нумерация пропущена и у этой нумерации состояние 1/3 то вызываем окно с подтверждением
        if(this.getDiagnostic.methods === 'skip' && this.getDiagnostic.levels[10].visibleType !== 2) {
            this.changeFlagMissingStep({ flag: true, index: 10 });
        } else {
            this.getMkb();
            this.getDataDiagnoses({ testId: this.$route.params.id, diagnoseType: 3 })
                .then((res) => {
                    if(res.length === 0) this.addDiagnose({ type: 3, name: 'finaly' });
                })
        }
    }
}
</script>
